import { render, staticRenderFns } from "./services-list.vue?vue&type=template&id=e158539c&scoped=true&"
import script from "./services-list.vue?vue&type=script&lang=js&"
export * from "./services-list.vue?vue&type=script&lang=js&"
import style0 from "./services-list.vue?vue&type=style&index=0&id=e158539c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e158539c",
  null
  
)

export default component.exports